import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import { compose, lifecycle } from 'recompose'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Grid from '@mui/material/Grid'
import ArrowDownIcon from '@mui/icons-material/ExpandMore'
import ArrowUpIcon from '@mui/icons-material/ExpandLess'
import Collapse from '@mui/material/Collapse'
import { showModal, fetchOccupationInfoModel, updateOccupationDisplayOrders } from '../../../redux/actions'
import ReorderOccupation from './ReorderOccupation'
import {
	selectPublishedOccupations,
	selectPublicOccupations,
	selectAllowedVerificationTypeGroups,
	hasPolicy,
} from '../../../redux/selectors'
import { REORDER_AFFILIATION_TAXONOMY } from '../../../auth/policies'
import PrivateLabel from './PrivateLabel'
import { withStyles } from '@mui/styles'
import TaxonomyListSubheader from './TaxonomyListSubheader'
import { StatusIndicator } from '../../@Common/StatusIndicator/StatusIndicator'
import { formatVerificationType } from '../../../formatting'

export const getAllowedVerificationTypeGroup = (occupationId, allowedVerificationTypeGroups) => {
	let foundGroup = allowedVerificationTypeGroups.find(x => x.occupationId === occupationId)
	if (!foundGroup) return null

	let allowedVerificationTypes = foundGroup.allowedVerificationTypes
	if (!allowedVerificationTypes || allowedVerificationTypes.length < 1) return null

	return (
		<div className="text-muted text-right" style={{ marginTop: '0px', padding: '0px 15px' }}>
			{allowedVerificationTypes.map((v, i) => (
				<span key={v.verificationTypeId}>
					{i === 0 ? formatVerificationType(v.verificationTypeName) : `, ${formatVerificationType(v.verificationTypeName)}`}
				</span>
			))}
		</div>
	)
}

const getOccupationHeader = (
	occupation,
	hasChildren,
	onEditOccupation,
	onEditOccupationName,
	published,
	isPrivate,
	classes
) => (
	<div>
		<div style={{ float: 'left' }}>
			<span className="text-muted" style={{ display: 'block', float: 'left', width: '22px', marginTop: '-1px', marginRight: '10px' }}>
				<small>{occupation.id}</small>
			</span>
			<span
				className={classes.editLink}
				onClick={hasChildren ? () => onEditOccupationName(occupation) : () => onEditOccupation(occupation)}
			>
				{occupation.name}
			</span>
		</div>
	</div>
)

const moveOccupationDown = (occupation, siblings, dispatch) => {
	if (occupation.displayOrder >= siblings.length - 1) return

	let siblingsBelow = siblings.filter(x => x.displayOrder === occupation.displayOrder + 1)
	occupation.displayOrder++
	if (siblingsBelow.length === 1) {
		let siblingBelow = siblingsBelow[0]
		siblingBelow.displayOrder--
		let updatedDisplayOrders = [
			{ occupationId: siblingBelow.id, displayOrder: siblingBelow.displayOrder },
			{ occupationId: occupation.id, displayOrder: occupation.displayOrder },
		]
		dispatch(updateOccupationDisplayOrders(updatedDisplayOrders))
	} else {
		let updatedDisplayOrders = [{ occupationId: occupation.id, displayOrder: occupation.displayOrder }]
		dispatch(updateOccupationDisplayOrders(updatedDisplayOrders))
	}
}

const moveOccupationUp = (occupation, siblings, dispatch) => {
	if (occupation.displayOrder <= 0) return

	let siblingsAbove = siblings.filter(x => x.displayOrder === occupation.displayOrder - 1)
	occupation.displayOrder--
	if (siblingsAbove.length === 1) {
		let siblingAbove = siblingsAbove[0]
		siblingAbove.displayOrder++
		let updatedDisplayOrders = [
			{ occupationId: siblingAbove.id, displayOrder: siblingAbove.displayOrder },
			{ occupationId: occupation.id, displayOrder: occupation.displayOrder },
		]
		dispatch(updateOccupationDisplayOrders(updatedDisplayOrders))
	} else {
		let updatedDisplayOrders = [{ occupationId: occupation.id, displayOrder: occupation.displayOrder }]
		dispatch(updateOccupationDisplayOrders(updatedDisplayOrders))
	}
}

const styles = () => ({
	switchRoot: {
		display: 'inline-block',

		width: 'auto',
		marginTop: '-3px',
	},
	formLabel: {
		width: 'auto',
		fontSize: '14px',
		fontWeight: '700',
		color: 'rgb(171, 171, 171)',
	},
})

const TaxonomyListItem = ({
	classes,
	index,
	occupation,
	depth,
	allowedVerificationTypeGroups,
	publishedOccupations,
	publicOccupations,
	onEditOccupation,
	onEditOccupationName,
	onEditDisplayOrder,
	siblings,
	canReorder,
	items,
	toggleItem,
}) => {
	let level = depth
	let hasChildren = occupation.children && occupation.children.length > 0
	let published = publishedOccupations.find(x => x.id === occupation.id) ? true : false
	occupation.published = published
	let publishedIconStatus = hasChildren ? undefined : published
	let isPrivate = publicOccupations.find(x => x.id === occupation.id) ? false : true
	let disableDown = occupation.displayOrder >= siblings.length - 1
	let disableUp = occupation.displayOrder <= 0

	return (
		<div>
			<TaxonomyListSubheader
				depth={depth}
				index={index}
				level={level}
				occupation={occupation}
				siblings={siblings}></TaxonomyListSubheader>
			<div>
				{/* secondaryText={getAllowedVerificationTypeGroup(occupation.id, allowedVerificationTypeGroups)} */}
				<ListItem
					open={items[occupation.id]}
					style={{
						height: 'auto',
						marginTop: '-1px',
						marginLeft: level * 52,
						width: 'auto',
						padding: '0px 24px',
						backgroundColor: '#fbfbfb',
						border: '1px solid #cfcfcf',
						cursor: 'default',
					}}
				>
					{canReorder && (
						<ListItemIcon style={{ marginTop: '5px' }}>
							<ReorderOccupation
								disableDown={disableDown}
								disableUp={disableUp}
								onClick={(e, direction) => onEditDisplayOrder(e, occupation, siblings, direction)}
							/>
						</ListItemIcon>
					)}
					<ListItemText style={{ width: '100%', marginTop: '5px', paddingLeft: '0' }}>
						<Grid container style={{ width: '100%', flexWrap: 'nowrap' }}>
							<Grid item style={{ cursor: 'pointer' }}>
								{getOccupationHeader(
									occupation,
									hasChildren,
									onEditOccupation,
									onEditOccupationName,
									publishedIconStatus,
									isPrivate,
									classes
								)}
							</Grid>

							<PrivateLabel isPrivate={isPrivate} />

							<Grid item style={{ flex: 1 }} />
							<Grid item>
								{getAllowedVerificationTypeGroup(occupation.id, allowedVerificationTypeGroups)}
							</Grid>
							<Grid item style={{ height: '33px' }}>
								{published === undefined
									? null
									: !hasChildren && (
										<span style={{ float: 'right', width: '10px', height: '10px' }}>
											<StatusIndicator publishedStatus={published} />
										</span>
									)}
							</Grid>
							{hasChildren && (
								<Grid item onClick={() => toggleItem(occupation.id)} style={{ cursor: 'pointer' }}>
									{
										items[occupation.id]
											? <ArrowUpIcon style={{ fill: '#9b9b9b' }} />
											: <ArrowDownIcon style={{ fill: '#9b9b9b' }} />
									}
								</Grid>
							)}
						</Grid>
					</ListItemText>
				</ListItem>
				<Collapse
					in={items[occupation.id]}
					unmountOnExit
					style={{ marginBottom: '30px' }}
					timeout={0}
					enter={false} //this is passed to the parent transition component without this is will lag significantly
					exit={false}
				>
					<List component="div" disablePadding>
						{hasChildren
							? occupation.children
								.sort((a, b) => {
									return a.displayOrder - b.displayOrder
								})
								.map((o, i) => (
									<EnhancedTaxonomyListItem
										key={o.id}
										index={i}
										occupation={o}
										allowedVerificationTypeGroups={allowedVerificationTypeGroups}
										publishedOccupations={publishedOccupations}
										publicOccupations={publicOccupations}
										onEditOccupation={onEditOccupation}
										onEditOccupationName={onEditOccupationName}
										onEditDisplayOrder={onEditDisplayOrder}
										siblings={occupation.children}
										canReorder={canReorder}
										classes={classes}
										toggleItem={toggleItem}
										items={items}
										depth={level + 1}
									/>
								))
							: []}
					</List>
				</Collapse>
			</div>
		</div>
	)
}

const mapStateToProps = (state, ownProps) => ({
	allowedVerificationTypeGroups: selectAllowedVerificationTypeGroups(state),
	publishedOccupations: selectPublishedOccupations(state),
	publicOccupations: selectPublicOccupations(state),
	canReorder: hasPolicy(REORDER_AFFILIATION_TAXONOMY)(state),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	onEditOccupationName: occupation => dispatch(showModal('EDIT_AFFILIATION_NAME', { occupation: occupation })),
	onEditOccupation: occupation =>
		dispatch(fetchOccupationInfoModel(occupation.id)).then(response =>
			dispatch(showModal('EDIT_AFFILIATION', { occupation: occupation }))
		),
	onEditDisplayOrder: (e, occupation, siblings, direction) => {
		e.stopPropagation()

		if (direction === 'down') {
			moveOccupationDown(occupation, siblings, dispatch)
		} else {
			moveOccupationUp(occupation, siblings, dispatch)
		}
	},
})

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	lifecycle({
		componentWillMount() { },
	}),
	withStyles(styles)
)

const EnhancedTaxonomyListItem = enhance(TaxonomyListItem)

export default enhance(injectSheet(styles)(TaxonomyListItem))
